import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Link } from "react-router-dom";

const STATUS_LABELS = {
  pending: "Εκκρεμεί",
  contacted: "Επικοινωνία",
  closed: "Κλειστό",
};

export default function MyInquiries() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/inquiries/mine").then((r) => setItems(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="my-inquiries-page" className="pt-32 pb-24 max-w-5xl mx-auto px-6 md:px-12">
      <div className="label-caps mb-4">Η Δραστηριότητά Σας</div>
      <h1 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight uppercase mb-12">
        Τα Αιτήματά Μου
      </h1>

      {loading ? (
        <div className="text-gray-500 uppercase text-xs tracking-widest font-display">Φόρτωση...</div>
      ) : items.length === 0 ? (
        <div className="border border-white/5 p-12 text-center">
          <p className="text-base text-gray-400 mb-6 font-light">Δεν έχετε υποβάλει κανένα αίτημα ακόμα.</p>
          <Link to="/buy" className="btn-primary">Δείτε τα Αυτοκίνητα</Link>
        </div>
      ) : (
        <div className="space-y-4">
          {items.map((i) => (
            <div key={i.id} data-testid={`inquiry-${i.id}`} className="bg-[#121212] border border-white/5 p-6 grid grid-cols-1 md:grid-cols-4 gap-4">
              <div className="md:col-span-2">
                <div className="text-[0.65rem] text-gray-500 uppercase tracking-widest mb-1 font-display">
                  {i.listing_type === "rent" ? "Αίτημα Ενοικίασης" : "Αίτημα Αγοράς"}
                </div>
                <Link to={`/cars/${i.car_id}`} className="font-display text-lg font-bold hover:text-[var(--gold)] transition-colors">
                  {i.car_title}
                </Link>
              </div>
              <div>
                <div className="text-[0.65rem] text-gray-500 uppercase tracking-widest mb-1 font-display">Κατάσταση</div>
                <span className={`text-xs uppercase tracking-widest font-display ${
                  i.status === "pending" ? "text-yellow-500" :
                  i.status === "contacted" ? "text-[var(--gold)]" : "text-gray-500"
                }`}>{STATUS_LABELS[i.status] || i.status}</span>
              </div>
              <div>
                <div className="text-[0.65rem] text-gray-500 uppercase tracking-widest mb-1 font-display">Ημερομηνία</div>
                <div className="text-sm text-gray-300">{new Date(i.created_at).toLocaleDateString("el-GR")}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
